var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zoezi-button',{attrs:{"block":_vm.block,"text":_vm.text,"link":_vm.link}})}
var staticRenderFns = []

export { render, staticRenderFns }